export default __webpack_public_path__ + "static/media/cross.7e52c62b.svg";